import { render, staticRenderFns } from "./Create-Payment-Credit-Note.vue?vue&type=template&id=4fbd84d2&scoped=true"
import script from "./Create-Payment-Credit-Note.vue?vue&type=script&lang=js"
export * from "./Create-Payment-Credit-Note.vue?vue&type=script&lang=js"
import style0 from "./Create-Payment-Credit-Note.vue?vue&type=style&index=0&id=4fbd84d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbd84d2",
  null
  
)

export default component.exports